import { defineComponent as _defineComponent } from 'vue';
import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, createBlock as _createBlock, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-f658ae96"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "box_note"
};
const _hoisted_2 = ["src"];
const _hoisted_3 = {
  class: "right_boxs"
};
const _hoisted_4 = {
  class: "title_text"
};
const _hoisted_5 = {
  class: "tabs_npx"
};
const _hoisted_6 = {
  key: 0,
  class: "is_recommend"
};
const _hoisted_7 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  class: "icons_top iconfont iconyy-tuijian"
}, null, -1));
const _hoisted_8 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "已推荐", -1));
const _hoisted_9 = [_hoisted_7, _hoisted_8];
import { ref, markRaw } from "vue";
import { addCaseApi, deleteCaseApi } from "@/service/modules/case";
import { ElMessage, ElMessageBox } from "element-plus";
import { QuestionFilled } from "@element-plus/icons-vue";
import coverDialog from "./cover-dialog.vue";
export default /*#__PURE__*/_defineComponent({
  __name: 'table-list',
  props: {
    data_list: {
      type: Array,
      default: () => []
    },
    loading: {
      type: Boolean,
      default: false
    }
  },
  emits: ["close", "get_list", "set_multipleSelection"],
  setup(__props, {
    emit: __emit
  }) {
    const props = __props;
    const emit = __emit;
    async function change_status(item, index) {
      let reqdata = {
        id: item.id,
        status: item.status == 1 ? 1 : 2
      };
      const res = await addCaseApi(reqdata);
      if (res.code == 0) {
        props.data_list[index].status = item.status == 1 ? 1 : 2;
        ElMessage.success("操作成功");
      }
    }
    async function set_istop(item, index) {
      let reqdata = {
        id: item.id,
        is_top: item.is_top == 1 ? 0 : 1
      };
      const res = await addCaseApi(reqdata);
      if (res.code == 0) {
        props.data_list[index].is_top = item.is_top == 1 ? 0 : 1;
        ElMessage.success("操作成功");
      }
    }
    const ID = ref(0);
    const is_show_l = ref(false);
    async function examine(item) {
      ID.value = item.id;
      is_show_l.value = true;
    }
    function closeDialog() {
      is_show_l.value = false;
    }
    async function editItem(id) {
      emit("close", id);
    }
    async function del_item(item) {
      ElMessageBox.confirm("该笔记删除后无法恢复，确定要删除吗？", "删除笔记", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
        icon: markRaw(QuestionFilled)
      }).then(async () => {
        try {
          let res = await deleteCaseApi(item.id);
          ElMessage.success("删除成功");
          emit("close");
        } catch {}
      }).catch(() => {});
    }
    const sort = ref("");
    function sortChange(column) {
      //   console.log(column);
      if (column.prop == "view_num") {
        if (column.order == "ascending") {
          sort.value = "view_num-asc";
        } else if (column.order == "descending") {
          sort.value = "view_num-desc";
        } else {
          sort.value = "id-desc";
        }
      }
      if (column.prop == "collect_num") {
        if (column.order == "ascending") {
          sort.value = "collect_num-asc";
        } else if (column.order == "descending") {
          sort.value = "collect_num-desc";
        } else {
          sort.value = "id-desc";
        }
      }
      if (column.prop == "last_week_view_num") {
        if (column.order == "ascending") {
          sort.value = "last_week_view_num-asc";
        } else if (column.order == "descending") {
          sort.value = "last_week_view_num-desc";
        } else {
          sort.value = "id-desc";
        }
      }
      if (column.prop == "ct_time") {
        if (column.order == "ascending") {
          sort.value = "ct_time-asc";
        } else if (column.order == "descending") {
          sort.value = "ct_time-desc";
        } else {
          sort.value = "id-desc";
        }
      }
      emit("get_list", sort.value);
      //   console.log(sort.value);
    }

    const multipleSelection = ref([]);
    function handleSelectionChange(val) {
      multipleSelection.value = val;
      if (multipleSelection.value.length > 0) {
        emit("set_multipleSelection", multipleSelection.value);
      }
    }
    return (_ctx, _cache) => {
      const _component_el_table_column = _resolveComponent("el-table-column");
      const _component_el_switch = _resolveComponent("el-switch");
      const _component_el_link = _resolveComponent("el-link");
      const _component_el_table = _resolveComponent("el-table");
      const _directive_loading = _resolveDirective("loading");
      return _openBlock(), _createElementBlock("div", null, [_withDirectives((_openBlock(), _createBlock(_component_el_table, {
        data: __props.data_list,
        onSortChange: sortChange,
        "cell-style": {
          fontSize: '14px',
          textAlign: 'center',
          color: '#2D2D2D'
        },
        "header-cell-style": {
          background: '#F7F9FB !important',
          color: '#111111',
          height: '42px',
          fontSize: '14px',
          textAlign: 'center'
        },
        onSelectionChange: handleSelectionChange
      }, {
        default: _withCtx(() => [_createVNode(_component_el_table_column, {
          type: "selection",
          width: "55"
        }), _createVNode(_component_el_table_column, {
          prop: "id",
          label: "笔记信息",
          width: "350"
        }, {
          default: _withCtx(scope => [_createElementVNode("div", _hoisted_1, [_createElementVNode("img", {
            class: "_lefts_image",
            src: scope.row.thumb,
            alt: ""
          }, null, 8, _hoisted_2), _createElementVNode("div", _hoisted_3, [_createElementVNode("div", _hoisted_4, _toDisplayString(scope.row.title), 1), _createElementVNode("div", _hoisted_5, [_createElementVNode("div", {
            class: _normalizeClass(["img_vie", scope.row.type == 1 ? 'img_vie_1' : 'img_vie_2'])
          }, _toDisplayString(scope.row.type == 1 ? "图文" : "视频"), 3), scope.row.is_top == 1 ? (_openBlock(), _createElementBlock("div", _hoisted_6, _hoisted_9)) : _createCommentVNode("", true)])])])]),
          _: 1
        }), _createVNode(_component_el_table_column, {
          prop: "view_num",
          label: "浏览数量",
          sortable: "view_num"
        }), _createVNode(_component_el_table_column, {
          prop: "collect_num",
          label: "喜欢数量",
          sortable: "collect_num"
        }), _createVNode(_component_el_table_column, {
          prop: "last_week_view_num",
          label: "权重分",
          sortable: "last_week_view_num"
        }), _createVNode(_component_el_table_column, {
          prop: "ct_time",
          label: "发布时间",
          sortable: "ct_time"
        }), _createVNode(_component_el_table_column, {
          prop: "status",
          label: "是否上架"
        }, {
          default: _withCtx(scope => [_createVNode(_component_el_switch, {
            modelValue: scope.row.status,
            "onUpdate:modelValue": $event => scope.row.status = $event,
            "active-color": "#3A64FF",
            "inactive-color": "#E9E9E9",
            "active-value": 1,
            "inactive-value": 2,
            onChange: $event => change_status(scope.row, scope.$index)
          }, null, 8, ["modelValue", "onUpdate:modelValue", "onChange"])]),
          _: 1
        }), _createVNode(_component_el_table_column, {
          label: "操作"
        }, {
          default: _withCtx(scope => [_createVNode(_component_el_link, {
            class: "m-r-10",
            type: "primary",
            onClick: $event => examine(scope.row)
          }, {
            default: _withCtx(() => [_createTextVNode("预览")]),
            _: 2
          }, 1032, ["onClick"]), _createVNode(_component_el_link, {
            class: "m-r-10",
            type: "primary",
            onClick: $event => editItem(scope.row.id)
          }, {
            default: _withCtx(() => [_createTextVNode("编辑")]),
            _: 2
          }, 1032, ["onClick"]), _createVNode(_component_el_link, {
            class: "m-r-10",
            type: "primary",
            onClick: $event => set_istop(scope.row, scope.$index)
          }, {
            default: _withCtx(() => [_createTextVNode(_toDisplayString(scope.row.is_top == 1 ? "取消推荐" : "推荐"), 1)]),
            _: 2
          }, 1032, ["onClick"]), _createVNode(_component_el_link, {
            type: "danger",
            onClick: $event => del_item(scope.row)
          }, {
            default: _withCtx(() => [_createTextVNode("删除")]),
            _: 2
          }, 1032, ["onClick"])]),
          _: 1
        })]),
        _: 1
      }, 8, ["data"])), [[_directive_loading, __props.loading]]), is_show_l.value ? (_openBlock(), _createBlock(coverDialog, {
        key: 0,
        id: ID.value,
        onCloseDialog: closeDialog,
        "dialog-visible": is_show_l.value
      }, null, 8, ["id", "dialog-visible"])) : _createCommentVNode("", true)]);
    };
  }
});